import { DatePickerProps } from "./DatePicker.types"
import DatePickerRange from "./DatePickerRange/DatePickerRange"
import DatePickerSingle from "./DatePickerSingle/DatePickerSingle"

export default function DatePicker(props: DatePickerProps) {
    if (props.mode === "range") {
        return <DatePickerRange {...props} />
    }
    return <DatePickerSingle {...props} />
}
